import React from 'react';
import PropTypes from 'prop-types';
import {
  Select, Card, MultiSelect, Checkbox,
} from '@ipc/ipc-components';
import SecureComponent from '../../../components/custom/SecureComponent';
import {
  ROLE_CARRIER, ROLE_OPERATOR, ROLE_ADMIN, hasAccess,
} from '../../../utils/access';
import { FormLabel } from '../../../elements';

const MainInfoComponent = ({
  values, validations, disabled, options, onSelectChange, mailClassDisabled, allMailClassCheckboxHandler,
  impcChecked, allImpcCheckBoxHandler, impcCheckboxDisableHandler,
}) => {
  const filterOption = (option, inputValue) => {
    const { label } = option;
    return label.toLowerCase().includes(inputValue.toLowerCase());
  };

  const filterCarrierOption = (option, inputValue) => {
    const { label } = option;
    const otherKey = options.carrier.filter(
      opt => opt.label === label && opt.label.toLowerCase().startsWith(inputValue.toLowerCase()),
    );
    return label.toLowerCase().includes(inputValue.toLowerCase()) || otherKey.length > 0;
  };

  const sortByLabel = (a, b) => ((a.label > b.label) ? 1 : -1);

  return (
    <Card>
      <div className="FormRow">
        <div className="FormRowInlineFlex">
          <SecureComponent roles={[ROLE_ADMIN, ROLE_CARRIER]}>
            <FormLabel title="Postal Operator" required hasError={!validations.operator}>
              <Select
                options={options.operator ? options.operator.sort(sortByLabel) : options.operator}
                value={values.operator}
                className="Input SingleSelect"
                onChange={onSelectChange}
                name="operator"
                isDisabled={disabled}
                filterOption={filterOption}
              />
            </FormLabel>
          </SecureComponent>
          <FormLabel title="Origin IMPC">
            <MultiSelect
              options={options.impc}
              value={values.impc}
              onChange={onSelectChange}
              name="impc"
              className="Input MultiSelect"
              isDisabled={hasAccess([ROLE_ADMIN]) && !values.operator}
            />
          </FormLabel>
          <Checkbox
            label="All IMPCs"
            name="allImpc"
            className="LeftTab"
            onChange={allImpcCheckBoxHandler}
            checked={impcChecked}
            disabled={impcCheckboxDisableHandler}
          />
        </div>
      </div>

      <SecureComponent roles={[ROLE_ADMIN, ROLE_OPERATOR]}>
        <div className="FormRow">
          <FormLabel title="Carrier" required hasError={!validations.carrier}>
            <Select
              options={options.carrier ? options.carrier.sort(sortByLabel) : options.carrier}
              value={values.carrier}
              className="Input SingleSelect"
              onChange={onSelectChange}
              name="carrier"
              isDisabled={disabled}
              filterOption={filterCarrierOption}
            />
          </FormLabel>
        </div>
      </SecureComponent>

      <FormLabel title="Mail Class" required hasError={!validations.mailClass}>
        <div className="FormRowInlineFlex">
          <MultiSelect
            options={options.mailClass}
            value={values.mailClass}
            className="Input MultiSelect"
            onChange={onSelectChange}
            name="mailClass"
            isDisabled={disabled || mailClassDisabled}
          />
          <Checkbox
            label="All Mail Classes (except empty receptacles)"
            name="allMailClasses"
            className="LeftTab"
            onChange={allMailClassCheckboxHandler}
            checked={mailClassDisabled}
            disabled={disabled}
          />
        </div>
      </FormLabel>
    </Card>
  );
};

MainInfoComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  disabled: PropTypes.bool,
  mailClassDisabled: PropTypes.bool,
  options: PropTypes.shape(),
  onSelectChange: PropTypes.func,
  allMailClassCheckboxHandler: PropTypes.func,
  impcChecked: PropTypes.bool,
  allImpcCheckBoxHandler: PropTypes.func,
  impcCheckboxDisableHandler: PropTypes.bool,
};

export default MainInfoComponent;
